import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

import { company } from '~/company/Company';
import { useMounted } from '~/hooks/useMounted';
import { orderStore, userStore } from '~/stores';
import type {
  RecommendationConfig,
  RecommendationStore,
} from '~/stores/RecommendationsStore';

import styles from './RecommendationSection.module.scss';
import RecommendationSlider from './RecommendationSlider';

interface RecommendationSectionProps {
  store: RecommendationStore;
  config: RecommendationConfig;
  className?: string;
}

const RecommendationSection = ({
  store,
  config,
  className,
}: RecommendationSectionProps) => {
  const isEnabled = company[config.companyFlag];
  const mounted = useMounted();

  useEffect(() => {
    const shouldLoad =
      isEnabled &&
      userStore.isAuthorized &&
      orderStore.etaWarehouseCode &&
      !store.productsRequest.isLoading;

    if (shouldLoad) {
      store.productsRequest.run();
    }
  }, []);

  // `userStore.isAuthorized` is persisted in localStorage, which is empty
  // during SSR and rehydrates asynchronously on the client. Gate on `mounted`
  // so the first client render stays a no-op like SSR, and the authorized
  // state (and its skeleton/slider) only appears once it's a safe, regular
  // post-hydration update.
  if (!isEnabled || !mounted || !userStore.isAuthorized || !store.collection) {
    return null;
  }

  return (
    <div className={className || styles.root}>
      <RecommendationSlider
        collection={store.collection}
        hideBadges={config.hideBadges}
        size={config.size}
      />
    </div>
  );
};

export default observer(RecommendationSection);
